<template>

  <div class="order-summary-wrapper">
    <h3 class="title">Order Summary</h3>
      <div class="order-summary-container">
        <div class="table-responsive">
          <table class="table cart-table review-order-table">
            <thead>
            <tr>
              <!-- <th width="30">#</th> -->
              <th class="product-name" width="70%">Product</th>
              <th class="product-total">Total</th>
            </tr>
            </thead>
            <tbody>
            <tr class="item" v-for="(line, index) in basketLines" :key="index"  >
              <td class="product-name">
                <span>{{line.boxSize}}</span> <span v-b-tooltip.hover :title="line.product.title">{{line.product.title.substr(0, 40)}}...
                </span>
              </td>
              <td class="product-total">
                <Currency :amount="line.price_incl_tax" />
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr class="cart-subtotal">
              <th id="left">Subtotal</th>
              <td><Currency :amount="subtotalPrice" /></td>
            </tr>
            <tr class="shipping">
              <th>Shipping</th>
              <td>
                <Currency :amount="shipAmount" v-if="isShippingCountryUSA" />
                <span v-else title="As Quoted">AQ</span>
              </td>
            </tr>
            <tr class="tax">
              <th>Tax</th>
              <td><Currency :amount="taxAmount" /></td>
            </tr>
            <tr class="order-total">
              <th>Total</th>
              <td>
                <strong><Currency :amount="totalPrice" /></strong>
              </td>
            </tr>
            </tfoot>
          </table><!-- /.review-order-table -->
        </div>
     </div>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';

  export default{
    computed: {
      ...mapGetters(['basketLines', 'taxAmount', 'shipAmount', 'subtotalPrice', 'totalPrice', 'isShippingCountryUSA']),
    },
    methods: {
      ...mapActions(['loadBasket'])
    },
    async created(){
      this.loadBasket();
    }
  }
</script>
<style scoped lang="scss">
@import '~scss/colors';


 .order-summary-container{
   background-color: #ededed;
   border:1px solid $gray-1;
    padding: 1em;
 }

 th {
   padding:.75rem 0;
 }

  .table-responsive {
    border-color: #EEEEEE;
  }

  .table {
    width: 100%;

    thead:first-child {
      tr:first-child {
        th {
          border-top: 0;
        }
      }
    }

    .product-total {
      text-align: right;
    }
  }

  tfoot {
    td {
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/basket/BasketSummary.vue